import { ListItemElement } from '~/components/PluginsEditor/types';
import getUpdatedBlockAttrs from '~/components/PluginsEditor/utils/serialize/getUpdatedBlockAttrs';

/**
 * serializes the ListItem element into html element
 * @param {ListItemElement} node - ListItem element
 */
const serialize = (node: ListItemElement, children: string): string => {
  const attrs = getUpdatedBlockAttrs(node);

  return `<li${attrs ? ` ${attrs}` : ''}>${children}</li>`;
};

export default serialize;
